import * as Yup from "yup";
import i18n from "../i18n";
import { ipWithOptionalPortRegex } from "../constants/regex";

export const FRDevicesSchema = Yup.object({
  deviceNameEn: Yup.string().required(
    i18n.language === "en"
      ? "Device Name (English) is required."
      : "اسم الجهاز (الإنجليزية) مطلوب.",
  ),
  deviceNameAr: Yup.string().required(
    i18n.language === "en"
      ? "Device Name (Arabic) is required."
      : "اسم الجهاز (العربية) مطلوب.",
  ),
  deviceType: Yup.string().required(
    i18n.language === "en" ? "Device Type is required." : "نوع الجهاز مطلوب",
  ),
  device: Yup.string(),
  ipAddress: Yup.string()
    .required(
      i18n.language === "en" ? "IP Address is required." : "عنوان IP مطلوب.",
    )
    .matches(
      ipWithOptionalPortRegex,
      i18n.language === "en"
        ? "Please enter a valid IP address."
        : "يرجى إدخال عنوان IP صالح.",
    ),
  description: Yup.string(),
  location: Yup.string().required(
    i18n.language === "en" ? "Location is required." : "الموقع مطلوب",
  ),
  building: Yup.string().required(
    i18n.language === "en" ? "Building is required." : "المبنى مطلوب",
  ),
  musterPoint: Yup.string(),
});
